import React, { ReactElement, useEffect, useState } from 'react'

import ScheduleHandler from '../../../../Database/handlers/ScheduleHandler'
import { ITodo, schedule, TodoObj } from '../../../../types/interfaces'
import "../CalendarCell/CalendarCell.css"
interface CaldendarCellProps{
  children?: React.ReactNode,
  id: string,
  todosArr:ITodo[]
}
export default function CalendarCell({ id, children , todosArr}: CaldendarCellProps) {
  const IsTodayClass = new Date().toLocaleString("en-us",{dateStyle:'long'}) == id ? "Today-Date" : ""
  const [Classes, setClasses] = useState({
    HasTodosClass:todosArr.length > 0 ? "Has-Todos" : ""
  })
  useEffect(() => {
    setClasses({
      HasTodosClass:todosArr.length > 0 ? "Has-Todos" : ""
    })
  }, [todosArr])
  

  return (
    
    <td key={id} id={`${id}`} className={`Calendar-Cell ${IsTodayClass} ${Classes.HasTodosClass}`}>
      <a href={`#${id}`}>
        {children} 
        {Classes.HasTodosClass?"▶":""}
      </a>
    </td>
  )
}
